var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3687"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3686"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Polygon 22",
    d: "M9.358 2.105a3 3 0 015.283 0l8.977 16.672a3 3 0 01-2.642 4.423H3.022a3 3 0 01-2.641-4.422z",
    fill: "#ed346a"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3643"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3642",
    fill: "#efefed"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3206",
    d: "M12.169 15.404h-.338a1.09 1.09 0 01-1.09-1.09V6.421a1.09 1.09 0 011.09-1.089h.338a1.09 1.09 0 011.09 1.09v7.892a1.09 1.09 0 01-1.09 1.09"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3207",
    d: "M12 19.757a1.419 1.419 0 111.419-1.419A1.419 1.419 0 0112 19.757"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.f1d82ee1.svg";
export { ForwardRef as ReactComponent };